import { render, staticRenderFns } from "./JigQuote.vue?vue&type=template&id=6b9a7a17"
import script from "./JigQuote.vue?vue&type=script&lang=ts"
export * from "./JigQuote.vue?vue&type=script&lang=ts"
import style0 from "./JigQuote.vue?vue&type=style&index=0&id=6b9a7a17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports